import { widgetTypes } from './widget.types'

export const fetchWidgetInfoStart = () => ({
  type: widgetTypes.FETCH_WIDGET_INFO_START,
})

export const setWidgetInfo = (widgetInfo) => ({
  type: widgetTypes.SET_WIDGET_INFO,
  payload: widgetInfo,
})

export const setActiveTriggerMessage = (message) => ({
  type: widgetTypes.SET_ACTIVE_TRIGGER_MESSAGE,
  payload: message,
})

export const setShowWidget = (showWidget) => ({
  type: widgetTypes.SET_SHOW_WIDGET,
  payload: showWidget,
})

export const setShowLuancher = (showLauncher) => ({
  type: widgetTypes.SET_SHOW_LAUNCHER,
  payload: showLauncher,
})

export const setShowTrigger = (showTrigger) => ({
  type: widgetTypes.SET_SHOW_TRIGGER,
  payload: showTrigger,
})

export const setlauncherContent = (content) => ({
  type: widgetTypes.SET_LAUNCHER_CONTENT,
  payload: content,
})

export const setHeaderExpand = (isExpanded) => ({
  type: widgetTypes.SET_HEADER_EXPAND,
  payload: isExpanded,
})

export const setAnimateWidget = (animate) => ({
  type: widgetTypes.SET_ANIMATE_WIDGET,
  payload: animate,
})

export const setOfficeHour = (isOfficeHour) => ({
  type: widgetTypes.SET_OFFICE_HOURE,
  payload: isOfficeHour,
})

export const setDisableTrigger = (disabled) => ({
  type: widgetTypes.SET_DISABLE_TRIGGER,
  payload: disabled,
})

export const setDisableTriggerMessages = () => ({
  type: widgetTypes.SET_DISABLE_TRIGGER_MESSAGES,
})

export const setDepartment = (department) => ({
  type: widgetTypes.SET_DEPARTMENT,
  payload: department,
})

export const toggleLauncher = () => ({
  type: widgetTypes.TOGGLE_LAUNCHER,
})

export const setWidgetReady = () => ({
  type: widgetTypes.SET_WIDGET_READY,
})

export const setWidgetSizeWideOpen = (isWideOpen) => ({
  type: widgetTypes.SET_WIDGET_SIZE_WIDE_OPEN,
  payload: isWideOpen,
})

export const setWidgetTab = (state) => ({
  type: widgetTypes.SET_WIDGET_TAB,
  payload: state,
})

export const setHelpTabState = (state) => ({
  type: widgetTypes.SET_HELP_TAB_STATE,
  payload: state,
})

export const setHelpTabFaq = (state) => ({
  type: widgetTypes.SET_HELP_TAB_FAQ,
  payload: state,
})

export const setHelpTabInputFocus = (state) => ({
  type: widgetTypes.SET_HELP_TAB_INPUT_FOCUS,
  payload: state,
})

export const setMessengerTabState = (state) => ({
  type: widgetTypes.SET_MESSENGER_TAB_STATE,
  payload: state,
})

export const setInjectedStyles = (styles) => ({
  type: widgetTypes.SET_INJECTED_STYLES,
  payload: styles,
})

export const setInjectedPosition = (position) => ({
  type: widgetTypes.SET_INJECTED_POSITION,
  payload: position,
})

export const setAutoMessageSize = (size) => ({
  type: widgetTypes.SET_AUTO_MESSAGE_SIZE,
  payload: size,
})

export const setForms = (newForms) => ({
  type: widgetTypes.SET_FORMS,
  payload: newForms,
})

export const setHeaderExpandedHeight = (height) => ({
  type: widgetTypes.SET_HEADER_EXPANDED_HEIGHT,
  payload: height,
})

export const setWidgetIconVisible = (isVisible) => ({
  type: widgetTypes.SET_WIDGET_ICON_VISIBLE,
  payload: isVisible,
})
